module.exports = __webpack_public_path__ + "static/monitoring-urls-webhook-b9ebf8a21d4721c34443c09dfeed7487.png";